var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowDownSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    className: "undefined",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n  .arrow-down-small{\n    fill:none;\n  }\n  .arrow-down-small .c{\n    fill:#646464;\n  }\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "arrow-down-small"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.8 8.5C3.6 8.7 3.6 9 3.8 9.2 4 9.4 4.3 9.4 4.5 9.2L9.8 3.6C10 3.4 10 3.1 9.8 2.9L4.5-2.7C4.3-2.8 4-2.8 3.8-2.7 3.6-2.5 3.6-2.2 3.8-2L8.8 3.3 3.8 8.5Z",
    className: "undefined"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowDownSmall);
export default __webpack_public_path__ + "static/media/icArrowDownSmall.bf5a6ed82e1952988da0b53cf5178307.svg";
export { ForwardRef as ReactComponent };